import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Paragraph } from '@digdir/designsystemet-react';
import { measurementText, type OverviewEntry } from '../surveyOverviewView';
import classes from '../WorkEnvironmentDashboardPage.module.css';

/** The evaluation of one round is the survey the next round starts from */
export const MeasurementNote = ({
  entry,
}: {
  entry: Extract<OverviewEntry, { kind: 'measurement' }>;
}): ReactElement => {
  const { t, i18n } = useTranslation();
  const { label, text } = measurementText(entry, t, i18n.language);
  return (
    <div role="note" className={classes.measurement}>
      <span aria-hidden="true" className={classes.measurementLine} />
      <Paragraph data-size="xs">
        <span className={classes.stepLabel}>{label}</span>
        <span className={classes.subtle}> · {text}</span>
      </Paragraph>
    </div>
  );
};
